// extracted by mini-css-extract-plugin
export var container = "layout-module--container--GDXsE";
export var content = "layout-module--content--1WD_k";
export var cartButton = "layout-module--cart-button--2Ycaw";
export var cartBadge = "layout-module--cart-badge--3ftQJ";